import { Box } from '@chakra-ui/react';
import SidebarContent from './components/Content';
import { AppRoute } from '../../routes';

interface SidebarProps {
	routes: AppRoute[];
	[x: string]: any;
}

function Sidebar(props: SidebarProps) {
	const { routes } = props;

	return (
		<Box display={{ base: 'none', xl: 'block' }} position='fixed' minH='100%'>
			<Box
				bg='navy.900'
				transition='0.2s linear'
				w='260px'
				h='100vh'
				m='0px'
				minH='100%'
				overflowX='hidden'
				boxShadow='14px 17px 40px 4px rgba(112, 144, 176, 0.08)'>
				<SidebarContent routes={routes} />
			</Box>
		</Box>
	);
}

export default Sidebar;
